import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, ComboBox, Divider, Switch, Text } from '@reveni-io/reveni-ui'

import { identifierValidationOptions } from './constants'
import { getGiftReturnsMessages } from './helpers'
import * as Styles from './styles'

const GiftReturnsConfiguration = ({
  allowsGiftReturns,
  onChangeAllowsGiftReturns,
  disabled,
  allowsUnifiedFlow,
  skipIdentifierValidation,
  onChangeSkipIdentifierValidation,
  giftCardAllowed,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!allowsUnifiedFlow) return null

  const { description, alert } = getGiftReturnsMessages(giftCardAllowed)

  return (
    <>
      <Divider />
      <Text type="titleM">{t('Devoluciones de regalos')}</Text>
      <Text type="bodyMRegular">{t(description)}</Text>
      <Styles.MainContainer isActive={allowsGiftReturns}>
        <Switch
          label={<Text type="titleS">{t('Habilitar devoluciones de regalos')}</Text>}
          checked={allowsGiftReturns}
          onChange={e => onChangeAllowsGiftReturns(e.target.checked)}
          disabled={disabled}
        />
        {allowsGiftReturns && (
          <>
            <Alert type="info">
              {t('Los reembolsos de devoluciones de regalo')}{' '}
              <Text type="bodyMBold" tag="span">
                {t(alert)}
              </Text>
            </Alert>
            <ComboBox
              backgroundColor={theme.colors.background.primary}
              label={t('Datos del pedido necesarios para iniciar el proceso.')}
              menuItems={identifierValidationOptions.map(option => ({ value: option.value, label: t(option.label) }))}
              handleChange={e => onChangeSkipIdentifierValidation(e.target.value === 'true')}
              value={skipIdentifierValidation ? 'true' : 'false'}
              disabled={disabled}
            />
            {skipIdentifierValidation && (
              <Alert type="warning">
                {t(
                  'No se recomienda permitir devoluciones de regalos utilizando únicamente un número de pedido. Dado que los números de pedido suelen ser secuenciales, usuarios malintencionados podrían adivinar números de pedido válidos y acceder a datos sensibles de pedidos o ventas, exponerte a costes logísticos innecesarios e impedir que usuarios legítimos soliciten devoluciones. Activa esta opción solo si comprendes y aceptas este riesgo.'
                )}
              </Alert>
            )}
          </>
        )}
      </Styles.MainContainer>
    </>
  )
}

export default GiftReturnsConfiguration
